import { BEACON_URL } from '@/config';

export const BEACON_INDIVIDUALS_PATH = '/individuals';

export const BEACON_INFO_ENDPOINT = BEACON_URL + '/overview';
export const BEACON_INDIVIDUALS_ENDPOINT = BEACON_URL + BEACON_INDIVIDUALS_PATH;
